import { Badge, CircularProgress, ListItemIcon, ListItemText } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { taskCountsSelector } from '../../background';
import ListItemLink from '../../components/ListItemLink';
import { useTranslation } from 'react-i18next';

export default function TasksMenuItem() {
  const { t } = useTranslation('settings');
  const { running } = useRecoilValue(taskCountsSelector);

  return running > 0 ? (
    <ListItemLink to="/settings/tasks" title={t('tasks.label')}>
      <ListItemIcon>
        <Badge color="secondary" badgeContent={running}>
          <CircularProgress size="1.7142857142857142rem" color="inherit" />
        </Badge>
      </ListItemIcon>
      <ListItemText primary={t('tasks.label')} />
    </ListItemLink>
  ) : null;
}
